import React, {useState, useEffect} from 'react'
import StudentService from '../../services/StudentService';
import StudentTable from '../../tables/StudentTable';
import { connect } from 'react-redux';

const ListPage = (props) => {
  const [student, setStudent] = useState([]);
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(25);
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState(null);
  const [pagination, setPagination] = useState({
    activePage: 1,
    itemsCountPerpage: 1,
    totalItemsCount: 1,
    lastPage: 1
  });

  useEffect(() => {
    StudentService.init(props.user.accessToken, props.campus.id);
  }, [props.campus, props.user]);

  useEffect(() => {
    (async function getRecords() {
      await getStudents(page, limit, filter);
    })();
  }, [limit, page, filter, props.campus, props.isLoad]);

  const getStudents = async (p, lim, fil) => {
    setLoading(true);
    try {
      const response = await StudentService.list(p,lim,fil)
      setStudent(response.data.data)
      setPagination({
        activePage: response.data.currentPage,
        itemsCountPerpage: response.data.perPage,
        totalItemsCount: response.data.total,
        lastPage: response.data['lastPage']
      })
      setLoading(false);
    } catch (error) {
      console.log(error)
    }
  }

  const changeLimit = lim => {
    setPage(1)
    setLimit(lim)
  }
  const changePage = p => {
    setPage(p)
  }

  const changeSearch = value => {
    setFilter(value)
  }

  const getStudent = (val, action) => {
    props.getStudent(val, action)
  }

  return (
    <>
      <StudentTable
        data={student}
        changeLimit={changeLimit}
        pagination={pagination}
        changePage={changePage}
        changeSearch={changeSearch}
        getStudent={getStudent}
        isLoading={loading}
      />
    </>
  );
}

const mapStateToProps = state => {
  return {
    user: state.user,
    campus: state.campus
  };
};


export default connect(mapStateToProps)(ListPage);